import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-recommend-form__field --mt-sp-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__text-4 js-acc-toggle" }, [
  /*#__PURE__*/_createElementVNode("span", null, "その他の連絡先")
], -1)
const _hoisted_3 = { class: "p-recommend-form__acc-content" }
const _hoisted_4 = { class: "p-recommend-form__list-2" }
const _hoisted_5 = { class: "p-recommend-form__field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "住所"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_7 = { class: "p-recommend-form__error-wrap" }
const _hoisted_8 = { class: "p-recommend-form__group-1 --type-2 js-kana-wrap" }
const _hoisted_9 = { class: "p-recommend-form__group-1-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "郵便番号", -1)
const _hoisted_11 = { class: "p-recommend-form__group-1-zip" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "住所を自動入力", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "p-recommend-form__group-1-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "都道府県", -1)
const _hoisted_18 = { class: "p-recommend-form__group-1-field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "市区町村", -1)
const _hoisted_20 = { class: "p-recommend-form__group-1-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "町名番地 ", -1)
const _hoisted_22 = { class: "p-recommend-form__group-1-field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "建物名・部屋番号", -1)
const _hoisted_24 = { class: "p-recommend-form__group-1-field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "都道府県カナ", -1)
const _hoisted_26 = { class: "p-recommend-form__group-1-field" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "市区町村カナ", -1)
const _hoisted_28 = { class: "p-recommend-form__group-1-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "町名・建物名カナ", -1)

import ValidatableField from '@/components/ValidatableField.vue';
import ResumeSelect from '../components/ResumeSelect.vue';
import { getZipCodeService } from '@/api/services/trnCareerService';
import { ref, watch } from 'vue';
import InvalidMessage from '@/components/InvalidMessage.vue';
import { useFieldValue, ValidationResult } from 'vee-validate';

type Props = {
    setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
    validateField: (field: string) => Promise<ValidationResult>;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'OtherContactsInfoForm',
  props: {
    setFieldValue: null,
    validateField: null
  },
  setup(__props: any) {

const props = __props as {
    setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
    validateField: (field: string) => Promise<ValidationResult>;
}



const loadZipCodeData = async (zipCode: string) => {
  const zipCodeResp = await getZipCodeService(zipCode);
  if (zipCodeResp && zipCodeResp.length > 0) {
    return zipCodeResp[0];
  }
};

const otherZipId1Field = useFieldValue('otherZipId1');
const otherZipId2Field = useFieldValue('otherZipId2');
const zipId1 = ref('');
const zipId2 = ref('');
watch(otherZipId1Field, (newVal) => {
  zipId1.value = newVal as string;
}, { immediate: true });
watch(otherZipId2Field, (newVal) => {
  zipId2.value = newVal as string;
},{ immediate: true });


const fillValueFromZipcode = async () =>
{
    let isNotExist = true;
    const zipCode1 = zipId1.value;
    const zipCode2 = zipId2.value;
    if(zipCode1 && zipCode2 && zipCode1.length == 3 && zipCode2.length == 4 )
    {
        const zipCode = (zipCode1??'') + (zipCode2??'');
        const zipCodeInfo = await loadZipCodeData(zipCode);
        if(zipCodeInfo)
        {
            isNotExist = false;
            props.setFieldValue('otherPrefId', zipCodeInfo.prefId);
            props.setFieldValue('otherPrefKanaName', zipCodeInfo.prefKanaName);
            props.setFieldValue('otherAddr1', zipCodeInfo.cityName);
            props.setFieldValue('otherAddr1Kana', zipCodeInfo.cityKanaName);
            props.setFieldValue('otherAddr2', zipCodeInfo.blockName);
            props.setFieldValue('otherAddr2Kana', zipCodeInfo.blockKanaName);
        }
    }
     if(isNotExist)
    {
        props.setFieldValue('otherZipId1', '');
        props.setFieldValue('otherZipId2', '');
        props.setFieldValue('otherPrefId', '');
        props.setFieldValue('otherPrefKanaName', '');
        props.setFieldValue('otherAddr1', '');
        props.setFieldValue('otherAddr1Kana', '');
        props.setFieldValue('otherAddr2', '');
        props.setFieldValue('otherAddr2Kana', '');
    }
    await props.validateField('otherZipId1');
    await props.validateField('otherZipId2');
    await props.validateField('otherPrefId');
    await props.validateField('otherAddr1');
    await props.validateField('otherAddr2');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(InvalidMessage, { name: "otherZipId1" }),
              _createVNode(InvalidMessage, { name: "otherZipId2" }),
              _createVNode(InvalidMessage, { name: "otherAddr1" }),
              _createVNode(InvalidMessage, { name: "otherAddr2" }),
              _createVNode(InvalidMessage, { name: "otherAddr3" }),
              _createVNode(InvalidMessage, { name: "otherAddr1Kana" }),
              _createVNode(InvalidMessage, { name: "otherAddr2Kana" })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__input-1 --zip-1",
                      id: "form-other-zip-1",
                      type: "text",
                      name: "otherZipId1",
                      placeholder: "000",
                      label: "郵便番号（前半）",
                      rules: {
                                                numeric: true,
                                                nullableMin: 3,
                                                max: 3,
                                                required: !!zipId2.value
                                            },
                      maxlength: "3"
                    }, null, 8, ["rules"]),
                    _hoisted_12,
                    _createVNode(ValidatableField, {
                      class: "p-recommend-form__input-1 --zip-2",
                      id: "form-other-zip-2",
                      type: "text",
                      name: "otherZipId2",
                      placeholder: "0000",
                      label: "郵便番号（後半）",
                      rules: {
                                                numeric: true,
                                                nullableMin: 4,
                                                max: 4,
                                                required: !!zipId1.value
                                            },
                      maxlength: "4"
                    }, null, 8, ["rules"])
                  ]),
                  _createElementVNode("button", {
                    onClick: _withModifiers(fillValueFromZipcode, ["prevent"]),
                    class: "p-recommend-form__zip-button",
                    type: "button"
                  }, _hoisted_15, 8, _hoisted_13)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(ResumeSelect, {
                  name: `otherPrefId`,
                  label: "都道府県",
                  id: "pref",
                  className: "p-recommend-form__select",
                  "empty-text": "都道府県を選択してください"
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(ValidatableField, {
                  class: "p-recommend-form__modal-input-2",
                  id: "form-other-address-1",
                  type: "text",
                  name: "otherAddr1",
                  placeholder: "市区町村を入力してください",
                  label: "市区町村",
                  rules: "max:100",
                  maxlength: "100"
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(ValidatableField, {
                  class: "p-recommend-form__modal-input-2",
                  id: "form-other-address-2",
                  type: "text",
                  name: "otherAddr2",
                  placeholder: "町名番地を入力してください",
                  label: "町名番地",
                  rules: "max:200",
                  maxlength: "200"
                })
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(ValidatableField, {
                  class: "p-recommend-form__modal-input-2",
                  id: "form-other-address-3",
                  type: "text",
                  name: "otherAddr3",
                  placeholder: "建物名・部屋番号を入力してください",
                  label: "建物名・部屋番号",
                  rules: "max:70",
                  maxlength: "70"
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(ValidatableField, {
                  class: "p-recommend-form__modal-input-2 js-ken-kana",
                  id: "form-other-area-kana",
                  type: "text",
                  name: "otherPrefKanaName",
                  placeholder: "都道府県のカナを入力してください",
                  label: "都道府県カナ",
                  readonly: ""
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(ValidatableField, {
                  class: "p-recommend-form__modal-input-2",
                  id: "form-other-address-1-kana",
                  type: "text",
                  name: "otherAddr1Kana",
                  placeholder: "市区町村のカナを入力してください",
                  label: "市区町村カナ",
                  rules: "zen_kana|max:70",
                  maxlength: "70"
                })
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(ValidatableField, {
                  class: "p-recommend-form__modal-input-2",
                  id: "form-other-address-2-kana",
                  type: "text",
                  name: "otherAddr2Kana",
                  placeholder: "町名・建物名のカナを入力してください",
                  label: "町名・建物名カナ",
                  rules: "zen_kana|max:70",
                  maxlength: "70"
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})